<template>
  <div>
    <app-header></app-header>
    <app-section></app-section>
  </div>
</template>

<script setup>
import '../style.css'
import appHeader from './components/header.vue'
import appSection from './components/section.vue'
</script>
